import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, HelpCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const questions = ['¿Esto me hará mal al hígado?', '¿Tengo que dejar las harinas para siempre?', '¿Puedo comer fruta?', '¿Qué desayuno ahora?', '¿Estoy empeorando sin darme cuenta?', '¿Y si en el próximo análisis sale peor?'];
  return <section className="py-20 bg-white" data-id="element-107">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6 font-['Tiro_Gurmukhi',_serif]" data-id="element-110">
            Tal vez hoy no sentís nada grave… <br className="hidden md:block" data-id="element-111" />
            <span className="text-[#D90606]" data-id="element-112">
              pero eso es justamente lo que más preocupa.
            </span>
          </h2>

          <p className="text-lg text-stone-600 leading-relaxed max-w-3xl mx-auto" data-id="element-113">
            Muchas personas descubren el hígado graso en un análisis de rutina.
            Al principio parece algo "controlable", pero después aparece la
            duda: <strong data-id="element-114">"¿Y si esto avanza y no me doy cuenta?"</strong>
          </p>
        </motion.div>

        <div className="bg-stone-50 rounded-3xl p-8 md:p-12 border border-stone-100 shadow-sm relative overflow-hidden" data-id="element-115">
          <div className="absolute top-0 right-0 -mt-4 -mr-4 text-stone-200 opacity-50" data-id="element-116">
            <AlertCircleIcon className="w-48 h-48" data-id="element-117" />
          </div>

          <div className="relative z-10" data-id="element-118">
            <p className="text-xl font-medium text-stone-800 mb-8" data-id="element-119">
              El problema es que mientras seguís sin saber qué comer, cada
              comida se vuelve una decisión cargada de miedo:
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-10" data-id="element-120">
              {questions.map((q, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.1
            }} className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border border-stone-100" data-id="element-121">
                  <HelpCircleIcon className="w-6 h-6 text-accent-500 shrink-0 mt-0.5" data-id="element-122" />
                  <span className="text-stone-700 font-medium" data-id="element-123">{q}</span>
                </motion.div>)}
            </div>

            <div className="bg-brand-50 border-l-4 border-brand-500 p-6 rounded-r-xl" data-id="element-124">
              <p className="text-lg text-brand-900 font-medium mb-2" data-id="element-125">
                No necesitás vivir con esa incertidumbre todos los días.
              </p>
              <p className="text-brand-700" data-id="element-126">
                Necesitás una guía clara, práctica y fácil de seguir para
                empezar a ordenar tu alimentación desde hoy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}